var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-row',[_c('van-col',{attrs:{"span":"24"}},[_c('p',[_vm._v("@2021 深圳市快启动科技有限公司 "),_c('br'),_c('a',{attrs:{"href":"http://beian.miit.gov.cn/"}},[_c('font',{staticStyle:{"color":"#2c3e50"}},[_vm._v("粤ICP备2020122573号")])],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }